import React, { FC } from "react"
import { CarrotRxModule } from "./CarrotRxModule"
import { AvaModule } from "./AvaModule"
import { useSelector } from "react-redux"
import { getBenefitConfiguration } from "reducers/benefitConfiguration"
import Interests from "../../../utils/Interests"
import { getIsAvaVisible } from "../../../derivedSelectors"
import { getInterest } from "../../../reducers/userInfo"
import { getAvaCheckoutStatus } from "../../../reducers/ava"

/**
 A combination module for showing CarrotRx and Ava's promotional modules.
 Shows/Hides modules based on CompanyInformation and UserInfo
 */
export const PromotionModules: FC = () => {
  const {
    featureConfig: { isCarrotRxEnabled: isCarrotRxActive }
  } = useSelector(getBenefitConfiguration)
  const interest = useSelector(getInterest)

  const showCarrotRx = getShowCarrotRx(isCarrotRxActive, interest)
  const isAvaVisible = useSelector(getIsAvaVisible)
  const avaCheckoutStatus = useSelector(getAvaCheckoutStatus)

  return (
    <>
      {showCarrotRx && <CarrotRxModule id="home-sidebar-carrot-rx-module" />}
      {isAvaVisible && avaCheckoutStatus !== "FAILED" && <AvaModule />}
    </>
  )
}

function getShowCarrotRx(isCarrotRxActive: boolean, interest: string) {
  return isCarrotRxActive && interest !== Interests.ADOPTING
}
